import React from 'react'
import { Bar, Radar } from "react-chartjs-2";

import ChartDataLabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js';
import HorizontalBarChartStacked from '../../CustomChart/HorizontalBarChartStacked';
import { flatten } from "lodash";

const Commit = (props) => {

    // const labelList = ["1", "2", "3", "4", "5", "6", "7"]
    const labelList = [["We have", "committed to", "Caring for", "Climate"], ["Committed to", "the Science-Based", "Targets initiative"], ["Committed to", "the Malaysia", "Digital Climate", "Action Pledge"], ["Committed to", "UNGC Principle 7"], ["Committed to", "UNGC Principle 8"], ["Committed to", "UNGC Principle 9"], ["Other"]]

    const horizontalStackData = {
        labels: props?.commit?.map(item => Object.keys(item)[0]?.split(" ")),
        
        datasets: [
        
            {
                data: props?.commit ? flatten(props?.commit?.map(item => parseInt(Object.values(item)))) : [],
                backgroundColor: "#34A853",
                hoverBackgroundColor: "green",
                label: '',
                borderRadius: 5,
            },
            {
                data: props?.commit ? flatten(props?.commit?.map(item => 100 - parseInt(Object.values(item)))) : [],
                backgroundColor: "#EA4335",
                hoverBackgroundColor: "red",
                label: '',
                borderRadius: 5,
            }
        ]
    };

    const horizontalStackOptions = {
        responsive: true,
        
        scales: {
            x: {
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
                stacked: true,
            },
            y: {
                max: 100,
                ticks: {
                    // display: false,
                    callback: function(value, index, ticks) {
                        return `${value}%`;
                    }
                },
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
                // title: {
                //     display: true,
                //     text: 'Average Score'
                // },
                stacked: true,
            },
            xAxes: [
                {
                    scaleLabel: {
                        display: false
                    },
                    gridLines: {
                        display: false
                    },
                    stacked: true,
                }
            ],
            yAxes: [
                {
                    gridLines: {
                        display: false,
                    },
                    stacked: true,
                }
            ]
        },

        plugins: {
            legend: {
                display: false,
            },
            
            datalabels: {
                anchor: 'end',
                // clamp: false,
                align: 'start',
                color: "white",
                display: function (context) {
                    return context.dataset.data[context.dataIndex] > 0;
                },
                font: {
                    weight: "bold",
                },
                formatter: (value) => {
                    return `${value}%`
                },
            },
        },
        
        pointLabelFontFamily: "Quadon Extra Bold",
        scaleFontFamily: "Quadon Extra Bold",
    };

    return (
        <div className='p-3'>
            <h5 className='mb-3'>Commit</h5>
            <div>
                <HorizontalBarChartStacked data={horizontalStackData} options={horizontalStackOptions} />
            </div>
            <h6 className='fw-bold text-dark text-center mt-3'>Company have any specific commitment or made a pledge on this topic?</h6>
        </div>
    )
};

export default Commit